module.exports = __webpack_public_path__ + "img/55.3d515ea5.png";